var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content billing-native" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.$checkPermission(["tab_ACTBilling_tabChargeList"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_Reconciliation"),
                      name: "tabReconciliation",
                      lazy: true
                    }
                  },
                  [_c("tab-reconciliation")],
                  1
                )
              : _vm._e(),
            _vm.$checkPermission(["tab_ACTBilling_tabBillingList"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_Bill"),
                      name: "tabBilling",
                      lazy: true
                    }
                  },
                  [_c("tab-billing")],
                  1
                )
              : _vm._e(),
            _vm.$checkPermission(["tab_ACTBilling_tabBillingGroupList"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_AccountStatement"),
                      name: "tabBillingGroup",
                      lazy: true
                    }
                  },
                  [_c("tab-billing-group")],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }